import React, { useState } from "react";
import clsx from "clsx";
import {  Accordion } from "react-bootstrap";
import Table from "react-bootstrap/Table";
import _ from "lodash";
import * as outstandingSelectors from "../../../../selectors/outstanding";
import CustomPriceSpan from "../../../../components/CustomPriceSpan";
import EmptyItemView from "../../../../components/EmptyItemView";
import LoadingOverlay from "../../../../components/LoadingOverlay";
import Helper from "../../../../utils/Helper";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faSort} from "@fortawesome/free-solid-svg-icons";
import {
  getOutstandingStatementTotalOutstandingAmountFullText,
  getOutstandingStatementTotalOutstandingAmountValue
} from "../../../../selectors/outstanding";

function CustomSettlement({ title, data, selectedCurrencyText, loading = false }) {
  const [activeKey, setActiveKey] = useState(["0"]);
  const [transactionDateOrderBy, setTransactionDateOrderBy] = useState(false);

  const orderByData = Helper.orderByData(data,transactionDateOrderBy)

  const handleAccordionClick = (eventKey) => {
    setActiveKey(activeKey === eventKey ? null : eventKey);
  };

  const totalOsSum = _.sumBy(orderByData, (item) =>
    outstandingSelectors.getOutstandingStatementTotalOutstandingAmountValue(item),
  );


  return (
    <div className="mt-4">
      <div className={clsx("custom-table-info-container padding-12px")}>
        <Accordion activeKey={activeKey} onSelect={handleAccordionClick} flush alwaysOpen>
          <Accordion.Item key="0" eventKey="0">
            <Accordion.Header className="outstanding-accord-header m-0">
              <h3 className={clsx("text-center")}>{title}</h3>
            </Accordion.Header>
            <Accordion.Body>
              <Table responsive="xxl">
                {!loading && !_.isEmpty(data) ? (
                  <thead>
                  <tr className={"custom-table-setoff-styled styled-outstanding-table"}>
                    <th style={{width: 120, verticalAlign: "bottom"}}>
                      <div
                          className="pointer"
                          onClick={() => {
                            setTransactionDateOrderBy((prev) => {
                              return !prev;
                            });
                          }}
                      >
                        Date
                        <FontAwesomeIcon
                            className="mx-2"
                            icon={faSort}
                        ></FontAwesomeIcon>
                      </div>
                    </th>
                    <th style={{width: 200, verticalAlign: "bottom"}}>Reference No</th>
                    <th style={{width: 100, verticalAlign: "bottom"}}></th>
                    <th style={{width: 140, verticalAlign: "bottom"}}></th>
                    <th style={{width: 100, verticalAlign: "bottom"}}></th>
                    <th style={{width: 120, verticalAlign: "bottom"}}></th>
                    <th style={{width: 120, verticalAlign: "bottom"}}></th>
                    <th style={{width: 150, verticalAlign: "bottom"}}></th>
                    <th style={{width: 120, verticalAlign: "bottom"}}></th>
                    <th style={{width: 150, verticalAlign: "bottom"}}>Outstanding Amount</th>
                    <th style={{width: 70, verticalAlign: "bottom"}}></th>
                    <th style={{width: 100, verticalAlign: "bottom"}}></th>
                  </tr>
                  </thead>
                ) : (
                    false
                )}
                <tbody>
                {!_.isEmpty(orderByData) ? (
                    _.map(orderByData, (trustMoneyDataList, index) => {
                      const transactionDate =
                          outstandingSelectors.getOutstandingStatementTransactionDate(
                              trustMoneyDataList,
                          );
                      const contractRefer =
                          outstandingSelectors.getOutstandingStatementContractReference(trustMoneyDataList);
                      const outstandingAmount =
                          outstandingSelectors.getOutstandingStatementOutstandingAmount(trustMoneyDataList);
                      const totalOutstandingBalText =
                          outstandingSelectors.getOutstandingStatementTotalOutstandingAmountFullText(
                              trustMoneyDataList,
                          );
                      return (
                          <tr key={index}>
                            <td style={{width: 120}}>{transactionDate}</td>
                            <td style={{width: 200}}>{contractRefer}</td>
                            <td style={{width: 100}}></td>
                            <td style={{width: 140}}></td>
                            <td style={{width: 100}}></td>
                            <td style={{width: 120}}></td>
                            <td style={{width: 120}}></td>
                            <td style={{width: 150, color: "white"}}></td>
                            <td style={{width: 120, color: "white"}}></td>
                            <td style={{width: 150}}>{totalOutstandingBalText}</td>
                            <td style={{width: 70}}></td>
                            <td style={{width: 100}}></td>
                          </tr>
                      );
                    })
                ) : (
                    <tr>
                      <td colSpan={12}>
                        <EmptyItemView extraCss={{"height": "100px"}}/>
                        <LoadingOverlay loading={loading}></LoadingOverlay>
                      </td>
                    </tr>
                )}
                </tbody>
                {!loading && !_.isEmpty(data) ? (
                    <tfoot>
                    <tr>
                      <th colSpan={9} className={clsx("text-end")}>
                        <span className="pe-2">Summary:</span>
                      </th>
                      <th>
                        <span>
                          {selectedCurrencyText} <CustomPriceSpan value={totalOsSum}/>
                        </span>
                      </th>
                    </tr>
                    </tfoot>
                ) : (
                    false
                )}
              </Table>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
      </div>
    </div>
  );
}
export default CustomSettlement;
